import { render, staticRenderFns } from "./CompanyReportingPage.vue?vue&type=template&id=0e202ed6"
import script from "./CompanyReportingPage.vue?vue&type=script&lang=js"
export * from "./CompanyReportingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports